'use strict';

import ready from './lib/ready';
import promiseIdle from './lib/promise-idle';
import {mutate} from './lib/promise-fastdom';
import ToggleArea from './lib/ToggleArea';
import SizeTransitionBehavior from './lib/ToggleArea_SizeBehavior';
import ButtonBehavior from './lib/ToggleArea_ButtonBehavior';
import BreakpointObserver from "./lib/BreakpointObserver";

ready()
    .then(promiseIdle())
    .then(mutate(function () {
        // create submenus toggles
        return Array.prototype.map.call(document.querySelectorAll('.menu-item--depth-0.menu-item-has-children'), item => {
            const toggle = item.querySelector('.menu-link--depth-0');
            toggle.setAttribute('aria-controls', `${item.id}-submenu`);

            const menu = item.querySelector('.menu--depth-1');
            if (item.id && !menu.id) {
                menu.id = `${item.id}-submenu`;
            }
            return toggle;
        });
    }))
    .then(function (toggles) {

        let ready = Promise.resolve();

        function backdrop(e) {
            if (e.type === 'submenu/before-open') {
                requestAnimationFrame(() => {
                    document.documentElement.classList.add('submenu-on');
                });
            } else {
                document.documentElement.classList.remove('submenu-on');
            }
        }

        document.addEventListener('submenu/before-open', backdrop);
        document.addEventListener('submenu/before-close', backdrop);

        // mode change
        (new BreakpointObserver('desktop')).observe(query => {
            ready = Promise.resolve(ready)
                .then((reset) => typeof reset === 'function' ? reset() : null)
                .then(() => query.matches ? initDesktopMode() : initMobileMode());
        });

        function initDesktopMode() {
            return Promise.resolve(toggles)
                .then(toggles => Promise.all(toggles.map(toggle => (new ToggleArea(
                    toggle.nextElementSibling,
                    'submenu',
                    [
                        new ButtonBehavior(toggle, {
                            closeOnBlur: true,
                            closeOnEsc: true,
                            closeOnLinkClick: false,
                            jail: false,
                        }),
                    ]
                )).ready())))
                .then((submenus) => function reset() {
                    return Promise.all(submenus.map(submenu => submenu.destroy()));
                });
        }

        function initMobileMode() {
            return Promise.resolve(toggles)
                .then(toggles => Promise.all(toggles.map(toggle => (new ToggleArea(
                    toggle.nextElementSibling, 'submenu', [
                        new ButtonBehavior(toggle, {
                            jail: false,
                            closeOnEsc: false,
                            closeOnLinkClick: false,
                            closeOnOutsideClick: false,
                            openedOnInit: !!toggle.nextElementSibling.querySelector('.current-menu-item'),
                        }),
                        new SizeTransitionBehavior(['height'])
                    ]
                )).ready())))
                .then((submenus) => function reset() {
                    return Promise.all(submenus.map(submenu => submenu.destroy()));
                });
        }
    })
;
